import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sheet, SheetContent, SheetTitle } from '@avala/ui/components/primitives/sheet';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAppearance } from '../../hooks/useAppearance';

export function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { dark, toggle } = useAppearance();
  return (
    <Sheet open={menuOpen} onOpenChange={setMenuOpen}>
      <div className="flex h-dvh min-h-0 bg-background">
        <a
          href="#workspace-content"
          className="sr-only z-[60] rounded-lg bg-primary p-3 text-primary-foreground focus:not-sr-only focus:fixed focus:left-4 focus:top-4"
        >
          Skip to content
        </a>
        <aside className="hidden w-60 shrink-0 border-r border-sidebar-border lg:block">
          <Sidebar />
        </aside>
        <SheetContent side="left" className="w-72 p-0" aria-describedby={undefined}>
          <SheetTitle className="sr-only">Support navigation</SheetTitle>
          <Sidebar onNavigate={() => setMenuOpen(false)} />
        </SheetContent>
        <div className="flex min-w-0 flex-1 flex-col">
          <Header dark={dark} onThemeChange={toggle} />
          <main
            id="workspace-content"
            tabIndex={-1}
            className="chat-scrollbar flex-1 overflow-auto px-4 py-6 outline-none sm:px-8 sm:py-8 lg:px-10"
          >
            <Outlet />
          </main>
        </div>
      </div>
    </Sheet>
  );
}
